const NotoSansCJKkrBold = require('./NotoSansCJKkr-Bold.woff');
const NotoSansCJKkrRegular = require('./NotoSansCJKkr-Regular.woff');
const PoppinsBold = require('./Poppins-Bold.woff');
const PoppinsRegular = require('./Poppins-Regular.woff');
const ErasITCBold = require('./ErasITC-Bold.woff');

export {
    NotoSansCJKkrBold,
    NotoSansCJKkrRegular,
    PoppinsBold,
    PoppinsRegular,
    ErasITCBold
}